<template>
  <v-dialog max-width="1000" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">Request cash detail</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)">close</v-icon>
      </v-toolbar>

      <v-card-text style="height: auto">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12 sm6 class="pa-1">
              <v-card class="card-detail">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 class="px-2 style-title-detail">
                      Type:
                      <v-btn
                        v-if="item_detais.mt_type == 1"
                        :ripple="false"
                        small
                        depressed
                        color="blue lighten-4"
                        class="style-status"
                        >แจ้งโอนเงิน</v-btn
                      >
                      <v-btn
                        v-else-if="item_detais.mt_type == 26"
                        :ripple="false"
                        small
                        depressed
                        color="green lighten-4"
                        class="style-status"
                        >แสกน QR</v-btn
                      >
                      <v-btn
                        v-else
                        :ripple="false"
                        small
                        depressed
                        color="deep-purple lighten-4"
                        class="style-status"
                        >ขอถอนเงิน</v-btn
                      >
                    </v-flex>

                    <v-flex xs12 class="px-2 style-title-detail">
                      Rider name :
                      <span class="style-data-detail">{{
                        item_detais.mt_user_id
                      }}</span>
                    </v-flex>
                    <v-flex xs12 class="px-2 style-title-detail">
                      Cash :
                      <span class="style-data-detail">{{
                        item_detais.cash
                      }}</span>
                    </v-flex>
                    <v-flex xs12 class="px-2 style-title-detail">
                      Credit :
                      <span class="style-data-detail">{{
                        item_detais.credit
                      }}</span>
                    </v-flex>
                    <v-flex xs12 class="px-2 style-title-detail">
                      Amount Money :
                      <span class="style-data-detail">{{
                        item_detais.cash + item_detais.credit
                      }}</span>
                    </v-flex>

                    <v-divider
                      style="border: 0.5px solid #e4e4e4"
                      class="mb-4 mt-3"
                    />
                    <div v-if="item_detais.mt_type != 26">
                      <v-flex xs12 class="px-2 style-title-detail">
                        Bank name :
                        <span class="style-data-detail">{{
                          item_detais.mt_bank_id
                        }}</span>
                      </v-flex>
                      <v-flex xs12 class="px-2 style-title-detail">
                        Account name :
                        <span class="style-data-detail">{{
                          item_detais.account_name
                        }}</span>
                      </v-flex>
                      <v-flex xs12 class="px-2 style-title-detail">
                        Account number :
                        <span class="style-data-detail">{{
                          item_detais.account_no
                        }}</span>
                      </v-flex>
                    </div>
                    <v-divider
                      style="border: 0.5px solid #e4e4e4"
                      class="mb-4 mt-3"
                    />
                    <v-flex xs12 class="px-2 style-title-detail">
                      Update at :
                      <span class="style-data-detail"
                        >{{ item_detais.date }} - {{ item_detais.time }}</span
                      >
                    </v-flex>
                    <v-flex xs12 class="px-2 style-title-detail">
                      Commission (ค่าชาร์จเวลาถอน/โอน) :
                      <span class="style-data-detail">{{
                        item_detais.mt_commission == null
                          ? "-"
                          : item_detais.mt_commission
                      }}</span>
                    </v-flex>
                    <v-flex xs12 class="px-2 style-title-detail">
                      Request cash :
                      <span class="style-data-detail">{{
                        item_detais.mt_money
                      }}</span>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <v-card class="card-img text-xs-center">
                <img
                  v-if="item_detais.mt_img"
                  :src="item_detais.mt_img"
                  contain
                  style="height: 400px; width: auto"
                />
                <img
                  v-else
                  :src="img"
                  contain
                  style="height: 400px; width: auto"
                />
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <!-- ซ่อนเมื่อสถานะเป็นapproved -->
      <v-card-actions v-if="item_detais.mt_approve == 0">
        <v-spacer />
        <v-btn
          color="red"
          :disabled="isEditRiderMoney"
          @click="reject(item_detais)"
          >reject</v-btn
        >
        <v-btn
          v-if="item_detais.mt_type != 26"
          color="green"
          :disabled="isEditRiderMoney"
          @click="approve(item_detais)"
          >approve</v-btn
        >
        <v-spacer />
      </v-card-actions>
      <!-- END--ซ่อนเมื่อสถานะเป็นapproved -->
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["dialog", "item_detais"],
  data() {
    return {
      valid: true,
      img: require("@/assets/back-office/banana.jpg"),
      valid: true,
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
    isEditRiderMoney() {
      if (!this.permission.rider.rider_money.rider_request) {
        return true;
      }
      return this.permission.rider.rider_money.rider_request == 1
        ? true
        : false;
    },
  },
  methods: {
    async approve(item) {
      this.$emit("setDialog", false);
      let check = await this.$store.dispatch(
        "fetchCashRider/approveCashReqest",
        item.mt_id
      );
      if (check == true) {
        item.mt_approve = 1;
      }
    },
    async reject(item) {
      this.$emit("setDialog", false);
      let check = await this.$store.dispatch(
        "fetchCashRider/rejectCashReqest",
        item.mt_id
      );
      if (check == true) {
        item.mt_approve = 2;
      }
    },
  },
};
</script>

<style scoped>
.style-status {
  border-radius: 20px;
}

.style-title-detail {
  font-size: 15px;
  margin-bottom: 10px;
}

.style-data-detail {
  font-size: 15px;
  color: #616a6b;
}

.card-detail {
  min-height: 400px;
}
.card-img {
  min-height: 400px;
  max-height: 400px;
}

.line-editpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}
.line-editpass:after {
  content: "Edit Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
